import React from 'react';
import FormField from '../FormField';
import SectionHeader from '../SectionHeader';
import { educationCourses } from '../../../utils/dwconstants';

const EducationBackground = ({ formData, handleChange, errors, isVisible, toggleSection }) => {
  const educationLevels = ['12th', ...Object.keys(educationCourses)];
  
  const studentStatusOptions = [
    { value: 'student', label: 'Student' },
    { value: 'fresher', label: 'Fresher' },
    { value: 'workingexperience', label: 'Working Experience 0-1years' },
    { value: 'workingexperience1-2', label: 'Working Experience 1-2years' },
    { value: 'workingexperience2-3', label: 'Working Experience 2-3years' },
    { value: 'workingexperience3-4', label: 'Working Experience 3-4years' },
    { value: 'workingexperience4-5', label: 'Working Experience 4-5years' },
    { value: 'workingexperience5-6', label: 'Working Experience 5-6years' },
    { value: 'workingexperience6-7', label: 'Working Experience 6-7years' },
    { value: 'workingexperience7-8', label: 'Working Experience 7-8years' },
    { value: 'workingexperience8-9', label: 'Working Experience 8-9years' },
    { value: 'workingexperience9-10', label: 'Working Experience 9-10years' },
    { value: 'workingexperience>10', label: 'Working Experience more than 10years' }
  ];

  const departmentOptions = [
    'IT/CSE', 
    'Mechanical', 
    'Civil/Architecture', 
    'EEE/ECE/Mechatronics', 
    'Arts and Science', 
    'Others'
  ];
  
  return (
    <div className="form-section">
      <SectionHeader 
        title="Educational Background" 
        isVisible={isVisible} 
        onClick={toggleSection} 
      />
      
      {isVisible && (
        <div className="section-content">
          <FormField
            label="Education Level"
            type="select"
            name="educationLevel"
            value={formData.educationLevel}
            onChange={handleChange}
            options={educationLevels}
            required={true}
          />
          
          {formData.educationLevel && educationCourses[formData.educationLevel] && (
            <FormField
              label="Education Course"
              type="select"
              name="educationCourse"
              value={formData.educationCourse}
              onChange={handleChange}
              options={educationCourses[formData.educationLevel]}
              required={true}
            />
          )}
          
          <FormField
            label="Department"
            type="select"
            name="department"
            value={formData.department}
            onChange={handleChange}
            options={departmentOptions}
            required={true}
          >
            <div>
              <select
                name="department"
                value={formData.department}
                onChange={handleChange}
                required
              >
                <option value="">Choose Your Department</option>
                {departmentOptions.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
              
              {formData.department === "Others" && (
                <input
                  type="text"
                  name="otherDepartment"
                  value={formData.otherDepartment || ""}
                  onChange={handleChange}
                  placeholder="Enter your department"
                  className="show"
                />
              )}
            </div>
          </FormField>
          
          <FormField
            label="Passed Out Year"
            type="number"
            name="passedout"
            value={formData.passedout}
            onChange={handleChange}
            error={errors.passedout}
          />
          
          <FormField
            label="Student Status"
            type="select"
            name="studentStatus"
            value={formData.studentStatus}
            onChange={handleChange}
            options={studentStatusOptions}
            placeholder="Choose Student status"
            required={true}
          />
        </div>
      )}
    </div>
  );
};

export default EducationBackground;